<template>
  <!-- 确认取消订阅的弹窗 -->
  <Prompt
    :isShown="promptStatus"
    :on-cancel="cancelSubscribe"
    :on-confirm="confirmSubscribe"
    :on-close="confirmSubscribe"
    confirm-text="继续订阅"
    cancel-text="取消订阅"
  >
    <p>取消订阅后，您将不再接受{{ name }}相关的折扣活动消息推送。确认要取消订阅吗？</p>
  </Prompt>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex"
import Prompt from "../Prompt.vue"

export default {
  name: "SubscribeItem",
  components: {
    Prompt
  },
  data() {
    return {
      promptStatus: false,
      subscribeId: "",
      groupId: ""
    }
  },
  computed: {
    ...mapState({
      subscribeGroups: state => state.subscribeGroups
    }),
    ...mapGetters(["pf"]),
    name() {
      return this.storeConfigWithGroupIdKey[this.groupId]
    }
  },
  methods: {
    ...mapActions([
      "getUserSubscribe",
      "updateSubscribeGroups",
      "setToastMsg",
      "storeConfigWithGroupIdKey",
      "setLoadingStart",
      "setLoadingEnd"
    ]),
    changePromptConfirmSubscribe({ promptStatus, subscribeId = "", groupId = "" }) {
      this.promptStatus = promptStatus
      this.subscribeId = subscribeId
      this.groupId = groupId
    },

    // 关闭确认取消订阅弹窗
    confirmSubscribe() {
      this.promptStatus = false
    },

    cancelSubscribe() {
      this.unSubscribeItem(this.subscribeId)
        .then(() => {
          this.promptStatus = false
        })
        .catch(() => {
          this.promptStatus = false
        })
    },

    /**
     * 调用订阅接口取消订阅业务
     */
    unSubscribeItem(subscribeId) {
      this.setLoadingStart()
      return this.getUserSubscribe({
        action: "cancel",
        groups: subscribeId
      })
        .then(() => {
          this.setLoadingEnd()
          this.updateSubscribeGroups({
            groupId: subscribeId
          })
          this.setToastMsg("取消订阅成功")
        })
        .catch(() => {
          this.setLoadingEnd()
          this.setToastMsg("系统繁忙，请稍后再试")
        })
    }
  }
}
</script>
